import { Injectable } from '@angular/core';
import { CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Auth } from '../../services/auth/auth-service';
import { NavService } from '../../../layout/main-layout/navigation/nav-service';
import { NAV_SECTIONS } from '../../../layout/main-layout/navigation/nav.config';
import { NavigationItem } from '../../../layout/main-layout/navigation/nav-model';

/**
 * Blocks typing the URL of a menu page that the user's sidebar does not show (for example an advertiser opening
 * /media), using the same role and module rules as the sidebar. Pages outside the menu, such as /profile, stay open.
 */
@Injectable({ providedIn: 'root' })
export class MenuGuard implements CanActivateChild {
  constructor(
    private readonly authService: Auth,
    private readonly navService: NavService,
    private readonly router: Router,
  ) {}

  canActivateChild(_: unknown, state: RouterStateSnapshot): boolean | UrlTree {
    const section = '/' + (state.url.split(/[/?#]/)[1] ?? '');
    const routes = (items: NavigationItem[]): string[] =>
      items.flatMap((item) => [...(item.route ? [item.route] : []), ...routes(item.children ?? [])]);
    const inMenu = routes(NAV_SECTIONS.flatMap((s) => s.items)).includes(section);
    if (!inMenu || section === '/dashboard') return true;
    const visible = routes(
      this.navService.getNavigation(this.authService.getRole()).flatMap((s) => s.items),
    );
    return visible.includes(section) || this.router.parseUrl('/dashboard');
  }
}
